import { Props } from "./LineChart"

export default (props: Props, setImage: React.Dispatch<React.SetStateAction<string>>): Chart.ChartConfiguration => ({
    type: "line",
    
    data: {
        labels: [],
        datasets: [
            {
                data: [],
                borderColor: "#909090",
                fill: false,
                borderDash: [2, 4],
                borderWidth: 4,
                pointBorderWidth: 1,
                pointBorderColor: "#909090",
                pointBackgroundColor: "#fff",
                pointRadius: isSmallWidth() ? 3 : 6,
                pointHoverRadius: 10,
                pointHoverBorderWidth: 1
            }
        ]
    },

    options: {
        layout: {
            padding: isSmallWidth() ? { top: 0, left: 0, bottom: 0, right: 0 } : { top: 30, left: 0, bottom: 0, right: 30 },
        },

        tooltips: {
            enabled: true,
            displayColors: false,
            titleFontSize: 16,
            titleFontColor: "#000",
            bodyFontSize: 16,
            bodyFontColor: "#000",
            backgroundColor: "whitesmoke",
            xPadding: 10,
            yPadding: 12,
            caretSize: 10,
            caretPadding: 15,
            cornerRadius: 10,
            callbacks: {
                label: function(tooltipItem: any, data: any) {
                    return tooltipItem.yLabel.toLocaleString() + " " + (props.valueUnit ?? "");
                }
            }
        },
        
        legend: {
            display: false
        },

        responsive: true,
        maintainAspectRatio: true,

        scales: {
            yAxes: [
                {
                    gridLines: {
                        display: true,
                        drawBorder: true,
                        drawOnChartArea: false
                    },
                    ticks: {
                        beginAtZero: false,
                        callback: value => value.toLocaleString()
                    },
                    
                    scaleLabel: {
                        display: props.yLabel !== undefined,
                        fontColor: "#000",
                        labelString: props.yLabel,
                        padding: isSmallWidth() ? 5 : 30,
                        fontSize: isSmallWidth() ? 11 : 14
                    }
                }
            ],
            xAxes: [
                {
                    gridLines: {
                        display: true,
                        drawBorder: true,
                        drawOnChartArea: false,
                    },
                    ticks: {
                        beginAtZero: false,
                    },
                    scaleLabel: {
                        display: props.xLabel !== undefined,
                        fontColor: "#000",
                        labelString: props.xLabel,
                        fontSize: isSmallWidth() ? 11 : 14,
                        padding: isSmallWidth() ? 5 : 30,
                    },
                }
            ]
        },
        
        animation: {
            onComplete: function() {
                setImage((this as Chart).toBase64Image());
            }
        }
    }
});

function isSmallWidth() {
    return window.innerWidth < 600;
}
